import Symbols from "~/components/child/Symbols";
import Dropdown from "~/components/child/ui/DropDown";
import { useTimeFramesList } from "~/utils/hooks";
import { changeWordFormatToTitleCase } from "~/utils/changeWordFormatToTitleCase";
import { resetAnalysisValues } from "./helper";

const NewAnalysis = ({
  isEditMode,
  analysisValues,
  setAnalysisValues,
  setNotification,
}) => {
  const timeFramesList = useTimeFramesList()?.data;

  const positionTypes =
    analysisValues.new.analysisType === "technical"
      ? ["Long", "Short"]
      : ["Long", "Short", "-"];
  return (
    <div className="px-2">
      <h2 className=" text-sky-70 text-base  font-roboto">New analysis</h2>

      <span className="text-oil-60 text-base font-roboto ">
        Please select the analysis information
      </span>

      <div className="flex flex-col gap-4 mt-8">
        <Symbols
          value={analysisValues?.new?.pair}
          onSelect={(item) => {
            const isPairChanged = analysisValues?.new?.pair?.value !== item?.value;
            setAnalysisValues({
              ...analysisValues,
              new: {
                ...analysisValues?.new,
                pair: {
                  key: item.key,
                  value: item.value,
                  image: item.image,
                  baseSymbol: item.baseSymbol,
                  quoteSymbol: item.quoteSymbol,
                  exchange: item.exchange,
                },
              },
              ...resetAnalysisValues(isPairChanged, analysisValues, setNotification),
            });
          }}
        />
        <Dropdown
          title="Analysis Type"
          value={
            analysisValues?.new?.analysisType
              ? {
                  key: analysisValues?.new?.analysisType,
                  value: changeWordFormatToTitleCase(analysisValues?.new?.analysisType),
                }
              : undefined
          }
          optionsList={["Technical", "Fundamental", "on-chain"].map((type) => ({
            key: type.toLowerCase(),
            value: type,
          }))}
          renderItem={(item) => (
            <span className="py-3 pl-2 text-xs font-roboto w-full flex cursor-pointer">
              {item.value}
            </span>
          )}
          onSelect={(item) => {
            const isTypeChanged =
              analysisValues?.new?.analysisType !== item?.value.toLowerCase();
            setAnalysisValues({
              ...analysisValues,
              new: {
                ...analysisValues.new,
                analysisType: item.key,
                positionType: "long",
              },
              ...resetAnalysisValues(isTypeChanged, analysisValues, setNotification),
            });
          }}
          editable={!isEditMode}
        />

        {analysisValues?.new?.analysisType === "technical" && (
          <>
            <Dropdown
              title="Technical Type"
              value={
                analysisValues?.technical?.type
                  ? {
                      key: analysisValues?.technical?.type,
                      value: changeWordFormatToTitleCase(analysisValues?.technical?.type),
                    }
                  : undefined
              }
              optionsList={["Setup", "Analysis"].map((type) => ({
                key: type.toLowerCase(),
                value: type,
              }))}
              renderItem={(item) => (
                <span className="py-3 pl-2 text-xs font-roboto w-full flex cursor-pointer">
                  {item.value}
                </span>
              )}
              onSelect={(item) => {
                const isTechnicalTypeChanged =
                  analysisValues?.technical.type !== item?.value.toLowerCase();
                setAnalysisValues({
                  ...analysisValues,
                  technical: {
                    ...resetAnalysisValues(
                      isTechnicalTypeChanged,
                      analysisValues,
                      setNotification
                    ).technical,
                    type: item.key,
                    timeFrame: { ...analysisValues.technical.timeFrame },
                  },
                });
              }}
            />
            <Dropdown
              title="Time frame"
              value={analysisValues?.technical?.timeFrame || undefined}
              optionsList={timeFramesList?.map((timeFrame) => ({
                key: timeFrame.id,
                value: timeFrame.time_frame,
              }))}
              renderItem={(item) => (
                <span className="py-3 pl-2 text-xs font-roboto w-full flex cursor-pointer">
                  {item.value}
                </span>
              )}
              onSelect={(item) => {
                const isTimeFrameChanged =
                  analysisValues?.technical?.timeFrame?.value !== item?.value;
                setAnalysisValues({
                  ...analysisValues,
                  technical: {
                    ...resetAnalysisValues(
                      isTimeFrameChanged,
                      analysisValues,
                      setNotification
                    ).technical,
                    timeFrame: {
                      key: item.key,
                      value: item.value,
                    },
                    type: analysisValues.technical.type,
                  },
                });
              }}
            />
          </>
        )}
        <Dropdown
          title="Position Type"
          value={
            analysisValues?.new?.positionType
              ? {
                  key: analysisValues?.new?.positionType,
                  value: changeWordFormatToTitleCase(analysisValues?.new?.positionType),
                }
              : undefined
          }
          optionsList={positionTypes?.map((positionType) => ({
            key: positionType.toLocaleLowerCase(),
            value: positionType,
          }))}
          renderItem={(item) => (
            <span className="py-3 pl-2 text-xs font-roboto w-full flex cursor-pointer">
              {item.value}
            </span>
          )}
          onSelect={(item) => {
            const isPositionTypeChanged =
              analysisValues?.new?.positionType.toLowerCase() !==
              item?.value.toLowerCase();
            setAnalysisValues({
              ...analysisValues,
              new: {
                ...analysisValues.new,
                positionType: item.key,
              },
              technical: {
                ...resetAnalysisValues(
                  isPositionTypeChanged,
                  analysisValues,
                  setNotification
                ).technical,
                timeFrame: { ...analysisValues.technical.timeFrame },
                type: analysisValues.technical.type,
              },
              fundamental: {
                ...resetAnalysisValues(
                  isPositionTypeChanged,
                  analysisValues,
                  setNotification
                ).fundamental,
              },
              onChain: {
                ...resetAnalysisValues(
                  isPositionTypeChanged,
                  analysisValues,
                  setNotification
                ).onChain,
              },
            });
          }}
        />
      </div>
    </div>
  );
};

export default NewAnalysis;
